module.exports = __webpack_public_path__ + "img/avatar-f2.952d54e1.png";